<template>
  <tr>
    <td>
      <strong v-text="name" />
      <br>
      {{ email }}
    </td>
    <td>
      <strong v-text="'Mobile'" />
      <br>
      {{ mobile }}
      <br>
      <div v-if="customFields.length > 0">
        <a
          class="uppercase underline mt-2 font-bold"
          @click="openCustomDetailsModal"
          v-text="'View All Details'"
        />
        <AccessRequestDetailsModal
          :custom-fields="customFields"
          :membership="accessRequest.membership"
          :show="showDetailsModal"
          @approve="updateApprovalQueue"
          @close="closeCustomDetailsModal"
          @reject="showDeleteAccessRequestModal = true"
        />
      </div>
    </td>
    <td>
      <div class="flex flex-wrap items-center">
        <ul class="tags max-w-xs ">
          <li
            v-for="group in groups"
            :key="`${accessRequest.uuid}-${group.uuid}-tag`"
            class="tag-interactive"
            @click.prevent="removeGroupFromPendingAccessRequest(group)"
          >
            {{ group.attributes.title }}
            <span class="ml-1 icon icon--small">
              <svg
                height="17"
                viewBox="0 0 17 17"
                width="17"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.097 15.905a.339.339 0 0 0 .472 0L8.667 8.96l7.097 6.943a.337.337 0 0 0 .472 0 .321.321 0 0 0 0-.46L9.138 8.5l7.098-6.943a.321.321 0 0 0 0-.461.339.339 0 0 0-.471 0L8.667 8.039 1.569 1.095a.339.339 0 0 0-.471 0 .321.321 0 0 0 0 .461L8.195 8.5l-7.098 6.943a.322.322 0 0 0 0 .462z"
                  fill-rule="evenodd"
                  stroke="#231F20"
                />
              </svg>
            </span>
          </li>
        </ul>
        <a
          class="ml-auto uppercase"
          href="#"
          @click.prevent="showGroupSelectorModal = true"
          v-text="'Add group'"
        />
      </div>
      <GroupSelectorModal
        :id="accessRequest.uuid"
        :preselected-groups="groups"
        :show="showGroupSelectorModal"
        @close="showGroupSelectorModal = false"
        @updateSelectedGroups="updateSelectedGroups"
      />
    </td>
    <td>
      <div class="select-container">
        <select
          v-model="role"
          @change="updateSelectedRole"
        >
          <option
            v-for="availableRole in availableRoles"
            :key="availableRole.uuid"
            :value="availableRole"
            v-text="removeUnionFromString(availableRole.attributes.title)"
          />
        </select>
      </div>
    </td>
    <td v-if="paymentsEnabled">
      <input
        :id="`${accessRequest.uuid}_require_fee`"
        v-model="requireMembershipFee"
        :name="`${accessRequest.uuid}_require_fee`"
        type="checkbox"
        @change="toggleMembershipFeeRequirement"
      >
      <label
        :for="`${accessRequest.uuid}_require_fee`"
        v-text="'Require'"
      />
    </td>
    <td>
      <input
        :id="`approve-${accessRequest.uuid}`"
        type="checkbox"
        :name="`approve-${accessRequest.uuid}`"
        :checked="isInApprovalQueue"
        @change="toggleApprove"
      >
      <label
        :for="`approve-${accessRequest.uuid}`"
        v-text="'Approve'"
      />
    </td>
    <td>
      <a
        class="btn btn--sm btn--danger"
        href="#"
        @click.prevent="showDeleteAccessRequestModal = true"
        v-text="'Reject'"
      />
      <RejectAccessRequestModal
        :access-request="accessRequest"
        :show="showDeleteAccessRequestModal"
        @accessRequestHasBeenRejected="accessRequestHasBeenRejected"
        @close="showDeleteAccessRequestModal = false"
      />
    </td>
  </tr>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import GroupSelectorModal from 'Membership/Resources/assets/js/components/groups/GroupSelectorModal'
import RejectAccessRequestModal from './RejectAccessRequestModal'
import AccessRequestDetailsModal from '../_modals/AccessRequestDetailsModal'

export default {
  name: 'AccessRequest',
  components: {
    AccessRequestDetailsModal,
    GroupSelectorModal,
    RejectAccessRequestModal,
  },
  props: {
    accessRequest: {
      type: Object,
      required: true,
    },
    approveAll: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showGroupSelectorModal: false,
      showDeleteAccessRequestModal: false,
      role: null,
      showDetailsModal: false,
      requireMembershipFee: true,
    }
  },
  computed: {
    isInApprovalQueue() {
      return this.$store.getters.membershipGetAccessRequestFromApprovalQueue(this.accessRequest)
    },
    name() {
      return `${this.accessRequest.membership.attributes.first_name} ${this.accessRequest.membership.attributes.last_name}`
    },
    email() {
      return this.accessRequest.membership.attributes.email
    },
    mobile() {
      return this.accessRequest.membership.phoneNumbers.data.length
        ? this.accessRequest.membership.phoneNumbers.data[0].attributes.phone_number
        : '-'
    },
    groups() {
      return this.accessRequest.membership.membershipGroups.data.length
        ? this.accessRequest.membership.membershipGroups.data
        : []
    },
    availableRoles() {
      return this.$store.getters.authRoles.filter(role => role.attributes.name !== 'base-permissions')
    },
    customFields() {
      const customFields = this.$store.state.union.accessRequestFields

      return customFields.length
        ? customFields.filter(field => this.isRequiredField(field))
        : []
    },
    paymentsEnabled() {
      return this.$root.Union.payments_enabled
    },
  },
  watch: {
    approveAll(newVal) {
      if (newVal) {
        this.updateApprovalQueue()
      }
    },
    availableRoles(newVal) {
      if (newVal.length) {
        this.role = this.availableRoles.find(role => role.attributes.name === 'union-member')
      }
    },
  },
  mounted() {
    this.requireMembershipFee = this.accessRequest.membership.attributes.require_membership_fee
  },
  methods: {
    ...mapActions({
      updateMembership: 'membershipUpdateMembership',
    }),
    updateSelectedRole() {
      if (this.isInApprovalQueue) {
        this.updateApprovalQueue()
      }
    },
    removeUnionFromString(role) {
      return _.upperFirst(role.replace('Union ', ''))
    },
    accessRequestHasBeenRejected(accessRequest) {
      this.$store.commit('membershipRemoveApprovalForAccessRequest', this.accessRequest)
      this.$store.commit('membershipRejectPendingAccessRequest', accessRequest)
    },
    updateSelectedGroups(selectedGroups) {
      this.$store.commit('membershipUpdatePendingAccessRequestGroups', {
        groups: selectedGroups,
        accessRequest: this.accessRequest,
      })

      if (this.isInApprovalQueue) {
        this.updateApprovalQueue()
      }
    },
    removeGroupFromPendingAccessRequest(group) {
      this.$store.commit('membershipRemoveGroupFromPendingAccessRequest', {
        group,
        accessRequest: this.accessRequest,
      })

      if (this.isInApprovalQueue) {
        this.updateApprovalQueue()
      }
    },
    toggleApprove() {
      if (this.isInApprovalQueue) {
        this.$store.commit('membershipRemoveApprovalForAccessRequest', this.accessRequest)
      } else {
        this.updateApprovalQueue()
      }
    },
    updateApprovalQueue() {
      this.accessRequest.role = this.role

      this.$store.commit('membershipQueueApprovalForAccessRequest', this.accessRequest)
    },
    openCustomDetailsModal() {
      this.showDetailsModal = true
    },
    closeCustomDetailsModal() {
      this.showDetailsModal = false
    },
    isRequiredField(field) {
      return field.rules.data.filter(rule => rule.attributes.type === 'required').length
    },
    toggleMembershipFeeRequirement() {
      this.$emit('processing')

      this.updateMembership({
        membershipUuid: this.accessRequest.membership.uuid,
        data: {
          require_membership_fee: this.requireMembershipFee,
          phone_numbers :  this.accessRequest.membership.phoneNumbers.data.map(phoneNumber => ({
            uuid: phoneNumber.uuid,
            is_visible: phoneNumber.attributes.is_visible,
            receives_sms: phoneNumber.attributes.textable,
            phone_number: phoneNumber.attributes.phone_number,
            phone_number_country: phoneNumber.attributes.phone_number_country,
          })),
          membership_groups : this.accessRequest.membership.membershipGroups.data.map(group => group.uuid),
        },
      }).then(() => {
        this.$emit('doneProcessing')
      })
    },
  },
}
</script>
